/**
 * Copyright (c) 2018 - present, Inbenta Technologies Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

(function () {
  /**
   * Function to display rating comment step.
   */
  function displayBlocks(name) {
    // hide all options active and display clicked one
    document.querySelectorAll('.inbenta-km__contact .inbenta-km__contact__option--active').forEach(block => {
      block.classList.remove('inbenta-km__contact__option--active');
    });
    document.querySelector('.inbenta-km__contact .inbenta-km__contact__option--' + name).classList.add('inbenta-km__contact__option--active');

    // hide all options active and display clicked one
    document.querySelectorAll('.inbenta-km__contact .inbenta-km__contact__block--active').forEach(block => {
      block.classList.remove('inbenta-km__contact__block--active');
    });
    document.querySelector('.inbenta-km__contact .inbenta-km__contact__block--' + name).classList.add('inbenta-km__contact__block--active');
  }

  /**
   * Main function.
   */

  window.addEventListener('load', function () {
    let options = document.querySelectorAll('.inbenta-km__contact .inbenta-km__contact__option');
    for (let i = 0; i < options.length; i++) {
      options[i].addEventListener('click', function (e) {
        options[i].classList.forEach(className => {
          if (className !== 'inbenta-km__contact__option' && className !== 'inbenta-km__contact__option--active') {
            let name = className.split('--')[1];
            displayBlocks(name);
          }
        });
      });
    }
  });
})()
